import React from 'react';
import { RichText } from '../../../../../../hoc/components';
import { Step } from './steps';

export interface HeaderStep extends Step {
	icon: React.ReactNode;
	title: string;
	description: string;
}

const NextStep: React.FC<HeaderStep> = ({ icon, title, description }) => {
	return (
		<div className="flex flex-col md:flex-row items-center gap-5 md:gap-11">
			<div>
				<span className="sr-only">{title}</span>
				{icon}
			</div>
			<div>
				<RichText html={description} />
			</div>
		</div>
	);
};

export default NextStep;
